import {
  RemoveBackgroundBase64ResultDeepNestingFragment,
  BackgroundRemoverInsufficientCreditsErrorDeepNestingFragment,
  BackgroundRemoverNotConfiguredErrorDeepNestingFragment,
} from "@towersystems/roam-common/lib/generated-graphql-fragment";
import { gql } from "@apollo/client";

export const MUTATION_REMOVE_BACKGROUND_BASE_64 = gql`
  ${RemoveBackgroundBase64ResultDeepNestingFragment}
  ${BackgroundRemoverInsufficientCreditsErrorDeepNestingFragment}
  ${BackgroundRemoverNotConfiguredErrorDeepNestingFragment}
  mutation removeBackgroundBase64($base64: String!) {
    removeBackgroundBase64(base64: $base64) {
      ... on BackgroundRemoverInsufficientCreditsError {
        ...BackgroundRemoverInsufficientCreditsErrorDeepNesting
      }
      ... on BackgroundRemoverNotConfiguredError {
        ...BackgroundRemoverNotConfiguredErrorDeepNesting
      }
      ... on RemoveBackgroundBase64Result {
        ...RemoveBackgroundBase64ResultDeepNesting
      }
    }
  }
`;

export const MUTATION_PREVIEW_REMOVE_BACKGROUND_BASE_64 = gql`
  ${RemoveBackgroundBase64ResultDeepNestingFragment}
  ${BackgroundRemoverInsufficientCreditsErrorDeepNestingFragment}
  ${BackgroundRemoverNotConfiguredErrorDeepNestingFragment}
  mutation previewRemoveBackgroundBase64($base64: String!) {
    previewRemoveBackgroundBase64(base64: $base64) {
      ... on BackgroundRemoverInsufficientCreditsError {
        ...BackgroundRemoverInsufficientCreditsErrorDeepNesting
      }
      ... on BackgroundRemoverNotConfiguredError {
        ...BackgroundRemoverNotConfiguredErrorDeepNesting
      }
      ... on RemoveBackgroundBase64Result {
        ...RemoveBackgroundBase64ResultDeepNesting
      }
    }
  }
`;
